export default "__VITE_ASSET__pEOQBjPl__"